module.exports = __webpack_public_path__ + "img/v-3.5a2b55be.svg";